"use client";

import Link from "next/link";
import Image from "next/image";
import { FadeIn, HomeEyebrow, HomeHeading, HomeLead, HomeSection } from "~/components/siteglue/home/section-shell";
import { SITEGLUE_AGENT_SECTIONS } from "~/lib/siteglue/siteglue-agent-product";
import { SITEGLUE_PRODUCT_NAME } from "~/lib/siteglue/customer-terms";

export function SiteGlueHomeAgentPreview() {
  return (
    <HomeSection id="siteglue-agent" tone="slate">
      <FadeIn>
        <HomeEyebrow>{SITEGLUE_PRODUCT_NAME}</HomeEyebrow>
        <HomeHeading className="mt-4 text-4xl font-semibold sm:text-5xl">
          Built like the dashboard you will use
        </HomeHeading>
        <HomeLead>
          Inbox, Contacts, Profile, Team, Channels, Training, and Tools — the same seven sections
          as the app.
        </HomeLead>
      </FadeIn>

      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {SITEGLUE_AGENT_SECTIONS.map((section, index) => (
          <FadeIn key={section.id} delay={0.04 * (index + 1)}>
            <Link
              href={`/ai-employees#${section.id}`}
              className="block overflow-hidden rounded-2xl border border-slate-200 bg-white transition-colors hover:border-[#4f81bd]/40"
            >
              <Image
                src={section.imageSrc}
                alt={section.imageAlt}
                width={640}
                height={400}
                className="h-28 w-full object-cover object-top"
              />
              <div className="p-4">
                <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#4f81bd]">
                  {section.dashboardLabel}
                </p>
                <p className="mt-1 text-sm font-semibold text-slate-900">{section.heading}</p>
              </div>
            </Link>
          </FadeIn>
        ))}
      </div>
    </HomeSection>
  );
}
